import React, { useState } from "react";

import EditContact from "./EditContact";

import { useAppSelector, useAppDispatch } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { updateOwnUserMeta } from "../../../../redux/reducers/user";

import { RequestState } from "../../../../utils/RequestState";
import { FieldState } from "../../../../utils/ValidationFunctions";

type Props = {
  handleClose: () => void;
  full_name?: string;
  gender?: string;
  birthday?: number;
  prefecture?: string;
  address_line_1?: string;
  address_line_2?: string;
  phone?: string;
};

const EditContactContainer: React.FC<Props> = ({
  full_name,
  gender,
  birthday,
  prefecture,
  address_line_1,
  address_line_2,
  phone,
  handleClose,
}) => {
  const [fieldState, setFieldState] = useState<FieldState>();
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    if (fieldState !== undefined && auth_token) {
      const update_args: { [key: string]: string } = {};

      for (const key in fieldState) {
        if (fieldState[key][1] == false) {
          return;
        }

        const val = fieldState[key][0];

        if (typeof val === "string") {
          update_args[key] = val;
        }
      }

      setRequestState(RequestState.Doing);

      dispatch(
        updateOwnUserMeta({ auth_token: auth_token, update: update_args })
      ).finally(() => setRequestState(RequestState.Success));
    }
  };

  const handleInputChange = (value: string | undefined, name: string) => {
    let f: FieldState = {};
    if (fieldState !== undefined) {
      f = fieldState;
    }

    if (value !== undefined) {
      f[name] = [value, true];
      setRequestState(RequestState.Pending);
    } else {
      f[name] = ["", false];
    }
    setFieldState(f);
  };

  return (
    <EditContact
      full_name={full_name}
      gender={gender}
      birthday={birthday}
      prefecture={prefecture}
      address_line_1={address_line_1}
      address_line_2={address_line_2}
      phone={phone}
      handleClose={handleClose}
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      requestState={requestState}
    />
  );
};

export default EditContactContainer;
